import { InvoiceLineItemValidation } from 'src/redux/billing/billing.types';

/** API may omit status or use different casing; archived rows are hidden; non-active rows use fallback when needed. */
export function getDisplayableLineItemValidations(
  validations: InvoiceLineItemValidation[]
): InvoiceLineItemValidation[] {
  if (validations.length === 0) {
    return [];
  }
  const notArchived = validations.filter((v) => {
    const s = (v.status ?? '').trim().toLowerCase();
    return s !== 'archived';
  });
  const active = notArchived.filter((v) => {
    const s = (v.status ?? '').trim().toLowerCase();
    if (!s) {
      return true;
    }
    return s === 'active';
  });
  if (active.length > 0) {
    return active;
  }
  return notArchived;
}

export function fieldLabel(field: string): string {
  const f = field.toLowerCase();
  if (f === 'spend') {
    return 'Spend';
  }
  if (f === 'impressions') {
    return 'Impressions';
  }
  return field.replace(/_/g, ' ');
}
